<template>
  <div
    class="container-fluid d-flex align-items-center justify-content-between"
    id="topbar"
  >
    <div>
      <h2 class="m-0">{{ sectionName }}</h2>
    </div>
    <div>
      <h4 class="m-0">{{ displayName }}</h4>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("utils", ["sectionName"]),
    ...mapGetters("currentUser", ["displayName"]),
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables";

#topbar {
  height: 100px;
  background: transparent;

  h2 {
    font-family: $mulish;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.3px;
  }

  h4 {
    font-family: $mulish;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topbar/Topbar.vue